import * as React from 'react';
import { observer } from 'mobx-react-lite';
import type { WhiteSpaceProperty } from 'csstype';

import styles from './CalendarSurfaceItem.scss';

// the buffer to add to the text box height for decenders space
const heightBuffer = 1;

export type whiteSpaceType = 'nowrap' | 'normal' | 'auto';

export interface CalendarSurfaceItemClippingProps {
    lines: number;
    lineHeight: number;
    children?: React.ReactNode;
    whiteSpace?: whiteSpaceType;
}

/**
 * Template for calendar items content clipping
 */

const CalendarSurfaceItemClipping = observer(function CalendarSurfaceItemClipping(
    props: CalendarSurfaceItemClippingProps
) {
    let { children, lines, lineHeight, whiteSpace } = props;

    let wrap = null;
    switch (whiteSpace) {
        case 'nowrap':
        case 'normal':
            wrap = whiteSpace;
            break;
        case 'auto':
            wrap = lines === 1 ? 'nowrap' : 'normal';
            break;
        default:
            break;
    }

    let height =
        Math.floor(lines) > 0 && lineHeight
            ? Math.floor(lines) * lineHeight + heightBuffer
            : 'none';
    let style: React.CSSProperties = {
        minHeight: lines < 0 ? '0px' : height,
        height: lines < 0 ? '0px' : height,
        maxHeight: height,
        whiteSpace: wrap as WhiteSpaceProperty,
    };

    return (
        <span className={styles.clippingContainer} style={style}>
            {children}
        </span>
    );
});
export default CalendarSurfaceItemClipping;
